import { render, staticRenderFns } from "./DevelopmentPermit.vue?vue&type=template&id=9db680f0&scoped=true"
import script from "./DevelopmentPermit.vue?vue&type=script&lang=js"
export * from "./DevelopmentPermit.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentPermit.vue?vue&type=style&index=0&id=9db680f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db680f0",
  null
  
)

export default component.exports